<template>
  <div class="order-notice" v-if="visible">
    <!-- 富文本内容 -->
    <div v-if="richTextContent" class="rich-text-content" v-html="richTextContent"></div>
    <div class="footer-notice" v-if="footerText" v-html="footerText"></div>
  </div>
</template>

<script>
export default {
  name: 'OrderNotice',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    visible() {
      return this.config.visible !== false
    },
    // 富文本内容（优先使用）
    richTextContent() {
      return this.config.richText || this.config.content || ''
    },
    // 以下兼容旧配置
    title() {
      return this.config.title || '订购须知'
    },
    warnings() {
      return this.config.warnings || this.defaultWarnings
    },
    productInfo() {
      return this.config.productInfo || this.defaultProductInfo
    },
    benefitsTitle() {
      return this.config.benefitsTitle || '商品权益说明'
    },
    benefits() {
      return this.config.benefits || this.defaultBenefits
    },
    noticesTitle() {
      return this.config.noticesTitle || '注意事项'
    },
    notices() {
      return this.config.notices || this.defaultNotices
    },
    footerText() {
      return this.config.footerText || this.defaultFooterText
    }
  }
}
</script>

<style lang="less" scoped>
.order-notice {
  padding: 0.3rem 0.2rem;
  background: transparent;
  margin-top: 0.2rem;
}

// 富文本内容样式
.rich-text-content {
  font-size: 0.26rem;
  line-height: 1.8;
  color: #000;

  /deep/ h1, /deep/ h2, /deep/ h3 {
    font-weight: bold;
    margin: 0.2rem 0;
    color: #006AFF;
  }

  /deep/ h1 {
    font-size: 0.32rem;
  }

  /deep/ h2 {
    font-size: 0.3rem;
  }

  /deep/ h3 {
    font-size: 0.28rem;
  }

  /deep/ p {
    margin-bottom: 0.15rem;
    text-align: justify;
    color: #000;
  }

  /deep/ ul, /deep/ ol {
    padding-left: 0.4rem;
    margin: 0.15rem 0;
  }

  /deep/ li {
    margin-bottom: 0.1rem;
    color: #000;
  }

  /deep/ strong, /deep/ b {
    font-weight: bold;
    color: #000;
  }

  /deep/ a {
    color: #006AFF;
    text-decoration: underline;
  }

  /deep/ table {
    width: 100%;
    border-collapse: collapse;
    margin: 0.2rem 0;

    th, td {
      border: 1px solid #ddd;
      padding: 0.1rem;
      text-align: left;
    }

    th {
      background: #f5f5f5;
      font-weight: bold;
    }
  }

  /deep/ img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0.2rem 0;
  }
}

.notice-title {
  font-size: 0.3rem;
  font-weight: bold;
  color: #006AFF;
  margin-bottom: 0.2rem;
}

.notice-content {
  margin-bottom: 0.3rem;
}

.notice-item {
  font-size: 0.26rem;
  line-height: 1.6;
  margin-bottom: 0.15rem;
  color: #000;

  &.warning {
    .highlight {
      color: #000;
      font-weight: 500;
    }

    .warning-text {
      color: #E7401E;
      font-weight: bold;
    }
  }
}

.product-info {
  background: #F8F9FA;
  border-radius: 0.1rem;
  padding: 0.2rem;
  margin-bottom: 0.3rem;
}

.info-item {
  font-size: 0.26rem;
  line-height: 1.8;
  color: #000;

  .label {
    color: #000;
  }

  .value {
    color: #000;

    &.price {
      color: #E7401E;
      font-weight: bold;
    }
  }
}

.benefits-detail {
  margin-bottom: 0.3rem;
}

.detail-title {
  font-size: 0.28rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.15rem;
}

.detail-item {
  font-size: 0.24rem;
  line-height: 1.6;
  margin-bottom: 0.15rem;
  color: #000;

  .tag {
    color: #E7401E;
    font-weight: 500;
  }

  .text {
    color: #000;
  }
}

.notice-list {
  margin-bottom: 0.3rem;
}

.list-title {
  font-size: 0.28rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.15rem;
}

.list-item {
  font-size: 0.24rem;
  color: #000;
  line-height: 1.6;
  margin-bottom: 0.1rem;
}

.footer-notice {
  font-size: 0.22rem;
  color: #999;
  text-align: center;
  padding-top: 0.2rem;
  border-top: 1px dashed #eee;
}
</style>
